export const getTimeRemaining = (deadline) => {
    const now = new Date().getTime();
    const diff = deadline.getTime() - now;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { diff, days, hours, minutes, seconds };
};
